import { user } from "./utils/local-user";
import { checkRoleExist } from "./utils/utils";

export const getNavigations = () => [
    { name: 'Dashboard', path: '/dashboard/default', icon: 'dashboard' },
    { name: 'Logs', path: '/dashboard/logs', icon: 'dashboard' },
    { name: 'Help & Support', path: '/customer-chat', icon: 'support' },
    { name: 'Contact Us', path: '/contact-us', icon: 'mail' },
    checkRoleExist('products') ? { label: 'Products', type: 'label' } : undefined,
    checkRoleExist('products') ? {
        name: 'Products',
        icon: 'donut_large',
        children: [
            { name: 'Add Product', iconText: 'plus', path: '/product/add' },
            { name: 'All Products', iconText: 'SI', path: '/product/all' },
            { name: 'Sale Products', iconText: 'SU', path: '/product/sale' },
            { name: 'Featured Products', iconText: 'SU', path: '/product/featured' },
            { name: 'Products Reviews', iconText: 'SU', path: '/product/reviews' },
            { name: 'Products Reviews', iconText: 'SU', path: '/product/reviews' },
        ].filter(x => {

            const serviceArea = user();

            if (!isNaN(parseInt(serviceArea))) {
                if (x.name === 'Sale Products') {
                    return false;
                }
                if (x.name === 'Featured Products') {
                    return false;
                }
                if (x.name === 'Products Reviews') {
                    return false;
                }
            }
            return true;

        }),
    } : undefined,
    checkRoleExist('shipping') ? { label: 'Shipping & Methods', type: 'label' } : undefined,
    checkRoleExist('shipping') ? {
        name: 'Shipping',
        icon: 'local_shipping',
        children: [
            { name: 'Add Shipping', iconText: 'plus', path: '/shipping/add' },
            { name: 'Shipping List', iconText: 'SI', path: '/shipping/all' },
            { name: 'Shipping Address', iconText: 'SI', path: '/shipping/address' },
            { name: 'Payment Methods', iconText: 'SI', path: '/shipping/methods' },
        ],
    } : undefined,
    checkRoleExist('Product_Attribute') ? { label: 'Product Attributes', type: 'label' } : undefined,
    checkRoleExist('Product_Attribute') ? {
        name: 'Product Attributes',
        icon: 'edit_attributes',
        children: [
            { name: 'Add Sizes', iconText: 'SI', path: '/product/add_size' },
            { name: 'Add Colors', iconText: 'SU', path: '/product/add_color' },
            { name: 'Sizes', iconText: 'SI', path: '/product/sizes' },
            { name: 'Colors', iconText: 'SU', path: '/product/colors' }
        ],
    } : undefined,
    checkRoleExist('Product_Category') ? {
        name: 'Product Categories',
        icon: 'category',
        children: [
            { name: 'Add Categories', iconText: 'SI', path: '/add_category' },
            { name: 'Add Sub Categories', iconText: 'SI', path: '/add_sub_category' },
            { name: 'Categories', iconText: 'SI', path: '/category' },
            { name: 'Sub Categories', iconText: 'SU', path: '/subCategory' },
            { name: 'Brands', iconText: 'SU', path: '/brands' }
        ],
    } : undefined,

    checkRoleExist('Product_Category') ? {
        name: 'Mart',
        icon: 'museum',
        children: [
            { name: 'Add Mart', iconText: 'SI', path: '/add_mart' },
            { name: 'Marts', iconText: 'SI', path: '/marts' },
        ],
    } : undefined,


    checkRoleExist('Orders') ? { label: 'Orders', type: 'label' } : undefined,
    checkRoleExist('Orders') ? {
        name: 'Orders',
        icon: 'shopping_bag',
        path: '/orders'
    } : undefined,

    checkRoleExist('Sale') || checkRoleExist('Banner_Add') || checkRoleExist('Coupons') ? { label: 'Promotions', type: 'label' } : undefined,
    checkRoleExist('Sale') ? {
        name: 'Add Sale',
        icon: 'loyalty',
        path: '/add_sale'
    } : undefined,
    checkRoleExist('Sale') ? {
        name: 'Sales',
        icon: 'loyalty',
        path: '/sales'
    } : undefined,
    checkRoleExist('Coupons') ? {
        name: 'Coupons',
        icon: 'discount',
        path: '/coupons'
    } : undefined,
    checkRoleExist('Banner_Add') ? {
        name: 'Banners',
        icon: 'view_carousel',
        path: '/banners'
    } : undefined,
    checkRoleExist('Banner_Add') ? {
        name: 'Campaigns',
        icon: 'view_carousel',
        path: '/campaign/list'
    } : undefined,

    checkRoleExist('Notifications') ? { label: 'Notifications', type: 'label' } : undefined,
    //    checkRoleExist('Notifications') ? {
    //         name: 'Notifications',
    //         icon: 'notifications_active',
    //         path: '/notifications'
    //     } : undefined,
    checkRoleExist('Notifications') ? {
        name: 'Notification Campaigns',
        icon: 'notifications_active',
        path: '/notifications-campaign'
    } : undefined,


    checkRoleExist('Feedback') ? {
        name: 'FeedBack',
        icon: 'FeedBack',
        path: '/feedback'
    } : undefined,

    // { label: 'Feedback', type: 'label' },
    // {
    //     name: 'FeedBack',
    //     icon: 'try',
    //     path: '/feedback'
    // },

    checkRoleExist('Sellers') ? { label: 'Seller', type: 'label' } : undefined,
    checkRoleExist('Sellers') ? {
        name: 'Sellers',
        icon: 'store',
        path: '/sellers'
    } : undefined,
    checkRoleExist('Sellers Banks') ? {
        name: 'Seller Banks',
        icon: 'account_balance_outlined',
        path: '/seller_banks'
    } : undefined,
    checkRoleExist('Sellers') ? {
        name: 'Payment Requests',
        icon: 'add_card',
        path: '/seller_requests'
    } : undefined,
    checkRoleExist('Customers') ? { label: 'Customer', type: 'label' } : undefined,
    checkRoleExist('Customers') ? {
        name: 'Customers',
        icon: 'people_alt_outlined',
        path: '/customers'
    } : undefined,
    checkRoleExist('Customers') ? {
        name: 'New Customer',
        icon: 'people_alt_outlined',
        path: '/new-customer'
    } : undefined,
   
    
    checkRoleExist('Admins') ? { label: 'Admins', type: 'label' } : undefined,
    checkRoleExist('Admins') ? {
        name: 'Add Admin',
        icon: 'admin_panel_settings',
        path: '/add_admin'
    } : undefined,
    checkRoleExist('Admins') ? {
        name: 'Admins',
        icon: 'admin_panel_settings',
        path: '/admins'
    } : undefined,
    checkRoleExist('Riders') ? { label: 'Rider & Service Area', type: 'label' } : undefined,

    // checkRoleExist('Riders') ? {
    //     name: 'Add Rider',
    //     icon: 'directions_bike',
    //     path: '/add_rider'
    // } : undefined,
    checkRoleExist('Riders') ? {
        name: 'Riders',
        icon: 'directions_bike',
        path: '/riders'
    } : undefined,
    checkRoleExist('Riders') ? {
        name: 'Riders Live',
        icon: 'dynamic_feed',
        path: '/live_rider'
    } : undefined,
    
    checkRoleExist('ServiceArea') ? {
        name: 'Zones',
        icon: 'WifiOutlined',
        path: '/service-areas'
    } : undefined,

    checkRoleExist('Report') ? {
        name: 'Reports',
        icon: 'Assessment',
        path: '/reports'
    } : undefined,


    // { label: 'Components', type: 'label' },
    // {
    //     name: 'Components',
    //     icon: 'favorite',
    //     badge: { value: '30+', color: 'secondary' },
    //     children: [
    //         { name: 'Auto Complete', path: '/material/autocomplete', iconText: 'A' },
    //         { name: 'Buttons', path: '/material/buttons', iconText: 'B' },
    //         { name: 'Checkbox', path: '/material/checkbox', iconText: 'C' },
    //         { name: 'Dialog', path: '/material/dialog', iconText: 'D' },
    //         { name: 'Expansion Panel', path: '/material/expansion-panel', iconText: 'E' },
    //         { name: 'Form', path: '/material/form', iconText: 'F' },
    //         { name: 'Icons', path: '/material/icons', iconText: 'I' },
    //         { name: 'Menu', path: '/material/menu', iconText: 'M' },
    //         { name: 'Progress', path: '/material/progress', iconText: 'P' },
    //         { name: 'Radio', path: '/material/radio', iconText: 'R' },
    //         { name: 'Switch', path: '/material/switch', iconText: 'S' },
    //         { name: 'Slider', path: '/material/slider', iconText: 'S' },
    //         { name: 'Snackbar', path: '/material/snackbar', iconText: 'S' },
    //         { name: 'Table', path: '/material/table', iconText: 'T' },
    //     ],
    // },
    /*
    {
        name: 'Charts',
        icon: 'trending_up',
        children: [{ name: 'Echarts', path: '/charts/echarts', iconText: 'E' }],
    },*/
];
